import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'
import CTAButton from '../../../components/CTAButton.js'
import { motion } from "framer-motion";

import './ServicesOverview.css'
import './MServicesOverview.css'
import { boxvar2, boxvar2_1, boxvar2_2, boxvar2_3, boxvar2dyndelay, lP } from '../../../core.js'
import { faArrowRight, faMagnifyingGlassArrowRight } from '@fortawesome/free-solid-svg-icons';

import head_aiexpert from '../../../assets/pictures/sectionimages/head_aiexpert-cut_compressed.webp'
import iphone_appdev from '../../../assets/pictures/sectionimages/iphone_appdev-cut_compressed.webp'
import iphonecam_contentcreator from '../../../assets/pictures/sectionimages/iphonecam_contentcreator-cut_compressed.webp'
import macbook_webdev from '../../../assets/pictures/sectionimages/macbook_webdev-cut_compressed.webp'
import rack_serverhosting from '../../../assets/pictures/sectionimages/rack_serverhosting-cut_compressed.webp'
import cam_photography from '../../../assets/pictures/sectionimages/cam_photography-cut_compressed.webp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ServicesOverview() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"services"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Unsere Services</title>
                <meta property="og:title" content="Services" />
                <meta property="og:description" content="Wir bieten dir ein breites Spektrum an Dienstleistungen im Bereich Software-Entwicklung, KI & Data Science und Media an." />
                <meta name="description" content="Wir bieten dir ein breites Spektrum an Dienstleistungen im Bereich Software-Entwicklung, KI & Data Science und Media an." />
            </Helmet>
            <section className='sec_next' id='sec_next--services'>
                <div className='sec_next_cont' id="sec_next--services--cont" style={{ wordBreak: "break-word" }}>


                    <motion.div variants={boxvar2_1} className='about_section_cont' initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <br />
                        <h2>Dein starker Partner für die digitale Welt</h2>
                        <h3>Was wir für euch tun — und warum wir bleiben.</h3>
                        <p>
                            Die meisten Agenturen bauen eure Website und sind dann weg. Wir machen
                            es anders: Wir starten mit eurem Projekt und betreuen euch danach laufend
                            weiter – mit Wartung, Updates und einem festen Ansprechpartner. So wächst
                            eure Digitalisierung mit euch.
                            Daneben bieten wir fertige SaaS-Plattformen als Branchen-Lösungen an: <a style={{ textDecoration: 'underline' }} href='/projects/?type=projects'>Unsere Produkte</a>
                        </p>
                        <p>
                            Du fragst dich, was das kostet? In unserer transparenten Preisübersicht findest du alle Pakete auf einen Blick.
                        </p>
                        <br />
                        <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Zu den Preisen"} href={'/pricing'}></CTAButton>

                        <div className='small_services_cont'>

                            <motion.div variants={boxvar2dyndelay} className='small_services_box' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                                <img src={macbook_webdev} alt='Ein MacBook mit einer Webseite und Code daneben symbolisiert Webentwicklung' />

                                <div className='small_services_textbox'>
                                    <h3 onClick={() => { lP('/services/webdev') }} className='noselect'>&lt;Webentwicklung/&gt;</h3>
                                    <div>
                                        <span className='servicetype_tag'>Software</span>
                                    </div>
                                    <p>
                                        Vom professionellen Firmenportfolio über Onlineshop bis hin zur individuellen Plattformlösung – wir machen deine digitale Präsenz sichtbar und erfolgreich.<br />
                                        Ob modernes CMS oder maßgeschneiderte Self-Coded-Lösung:<br /><br />
                                        <b>Du entscheidest, wir setzen um.</b>
                                        <br />
                                    </p>

                                </div>
                                <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Zur neuen Webseite"} href={'/services/webdev'}></CTAButton>
                            </motion.div>

                            <motion.div variants={boxvar2dyndelay} className='small_services_box' initial="hidden" exit="hidden" whileInView="visible" custom={0.6} viewport={{ once: false, margin: "-50px" }}>
                                <img src={iphone_appdev} alt='Ein iPhone mit einem Layout-Entwurf auf dem Display symbolisiert Appentwicklung' />
                                <div className='small_services_textbox'>
                                    <h3 onClick={() => { lP('/services/appdev') }} className='noselect'>&lt;Appentwicklung/&gt;</h3>
                                    <div>
                                        <span className='servicetype_tag'>Software</span>
                                    </div>
                                    <p>
                                        So einfach wie noch nie – mit uns als erfahrenem Partner an deiner Seite!<br />
                                        Ob Kundenbindung, interne Prozesse oder Speziallösungen: Deine Vision wird zur smarten Anwendung:<br /><br />
                                        <b>intuitiv, performant, zukunftssicher.</b>
                                        <br />
                                    </p>
                                </div>
                                <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Zur eigenen App"} href={'/services/appdev'}></CTAButton>

                            </motion.div>

                            <motion.div variants={boxvar2dyndelay} className='small_services_box' initial="hidden" exit="hidden" whileInView="visible" custom={0.9} viewport={{ once: false, margin: "-50px" }}>
                                <img src={rack_serverhosting} alt='Serverrack-Schrank symbolisiert die Dienstleistung Server Hosting' />

                                <div className='small_services_textbox'>
                                    <h3 onClick={() => { lP('/services/hosting') }} className='noselect'>&lt;Serverhosting/&gt;</h3>
                                    <div>
                                        <span className='servicetype_tag'>Software</span>
                                        <span className='servicetype_tag' style={{ backgroundColor: 'var(--ci_color_mainbg)' }}>Beratung</span>
                                    </div>
                                    <p>
                                        Eure Website muss immer erreichbar sein. Wir hosten sie auf Servern in
                                        Deutschland – DSGVO-konform, schnell und überwacht. Wenn etwas ist, kümmern
                                        wir uns, bevor ihr es merkt.<br /><br />
                                        <b>stabil, skalierbar, sicher</b >
                                        <br />
                                    </p>
                                </div>
                                <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Zum Hosting"} href={'/services/hosting'}></CTAButton>

                            </motion.div>

                            <motion.div variants={boxvar2dyndelay} className='small_services_box' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                                <img src={head_aiexpert} alt='Ein neon-blau leuchtendes Gehirn symbolisiert die Beratung im KI-Umfeld' />

                                <div className='small_services_textbox'>
                                    <h3 onClick={() => { lP('/services/ai') }} className='noselect'>&lt;AI-Expertise/&gt;</h3>
                                    <div>
                                        <span className='servicetype_tag'>Software</span>
                                        <span className='servicetype_tag' style={{ backgroundColor: 'var(--ci_color_mainbg)' }}>Beratung</span>
                                    </div>
                                    <p>
                                        Verbringt ihr Stunden mit wiederkehrenden Aufgaben? Wir zeigen euch, wo
                                        KI euch konkret Zeit spart – von automatischen Antworten bis zu besseren
                                        Prognosen. Kein Hype, sondern messbarer Nutzen für euren Alltag.<br /><br />
                                        <b>Effizient, individuell, datengestützt.</b>
                                        <br />
                                    </p>
                                </div>
                                <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Zur AI-Power"} href={'/services/ai'}></CTAButton>

                            </motion.div>

                            <motion.div variants={boxvar2dyndelay} className='small_services_box' initial="hidden" exit="hidden" whileInView="visible" custom={0.6} viewport={{ once: false, margin: "-50px" }}>
                                <img src={iphonecam_contentcreator} alt='Ein iPhone mit Videokamera daneben als Symbol für Socialmedia' />

                                <div className='small_services_textbox'>
                                    <h3 onClick={() => { lP('/services/content') }} className='noselect'>&lt;Content-Creator/&gt;</h3>
                                    <div>
                                        <span className='servicetype_tag' style={{ backgroundColor: 'var(--ci_color_warn)' }}>Media</span>
                                        <span className='servicetype_tag' style={{ backgroundColor: 'var(--ci_color_mainbg)' }}>Beratung</span>
                                    </div>
                                    <p>
                                        Organische Reichweite statt teurer Werbung – wir zeigen dir, wie’s geht.<br />
                                        Hebe dein Unternehmen mit starkem Social Media Content auf das nächste Level.<br />
                                        Mit gezielter Foto- und Videoproduktion, die deine Zielgruppe wirklich erreicht.
                                        <br />
                                    </p>
                                </div>
                                {/* <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Zum viralen Content"} onclick={() => { lP('/services/socialmedia') }}></CTAButton> */}
                                <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Mehr Content"} href={'/services/content'}></CTAButton>
                            </motion.div>

                            <motion.div variants={boxvar2dyndelay} className='small_services_box' initial="hidden" exit="hidden" whileInView="visible" custom={0.9} viewport={{ once: false, margin: "-50px" }}>
                                <img src={cam_photography} alt='Eine professionelle Kamera symbolisiert die Dienstleistung Fotografie' />

                                <div className='small_services_textbox'>
                                    <h3 onClick={() => { lP('/services/photos') }} className='noselect'>&lt;Fotografie/&gt;</h3>
                                    <div>
                                        <span className='servicetype_tag' style={{ backgroundColor: 'var(--ci_color_warn)' }}>Media</span>
                                    </div>
                                    <p>
                                        Bilder sagen mehr als Worte – vor allem, wenn sie professionell inszeniert sind.<br />
                                        Ob Businessporträts, Produktshootings oder Events:<br />
                                        Wir fangen Emotionen und Markenidentität in beeindruckenden Bildern ein.<br />
                                        Für deinen perfekten Auftritt – online wie offline.
                                    </p>
                                    {/* TODO seperate Seite mit Bild-Portfolio / Referenzen */}
                                </div>
                                <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Zu den Fotos"} href={'/services/photos'}></CTAButton>

                            </motion.div>

                            {/* -------  BIG BOTTOM ------- */}
                            <motion.div variants={boxvar2dyndelay} className='small_services_box small_services_box-bigbottom' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                                <div className='small_services_textbox'>
                                    <h3>&lt;Unsere Eigen-Produkte/&gt;</h3>

                                    <div>
                                        <span className='servicetype_tag'>Software</span>
                                    </div>
                                    <p>
                                        Hast du schon bei unseren Inhouse-Startups vorbeigeschaut?<br />
                                        Wir bieten out-of-the-box-Lösungen für dich und deine Kunden: <br /
                                        ><br />
                                        <span className='highlight_absatz'>
                                            Registrieren <FontAwesomeIcon icon={faArrowRight} /> Einrichten <FontAwesomeIcon icon={faArrowRight} /> Fertig
                                        </span>
                                        <br />
                                        <br />
                                        Unsere Softwareprodukte sind i.d.R. als Whitelabel-Webanwendung gebaut und können von dir eigenständig angepasst werden.<br />
                                        Zusätzliche Features können wir für dich gerne nachträglich einbauen.
                                    </p>
                                    <CTAButton className="" showArrow={false} customIcon={faMagnifyingGlassArrowRight} iconLeft={true} title={"Alle entdecken"} href={'/projects/?type=projects'}></CTAButton>
                                </div>
                            </motion.div>

                            <motion.div variants={boxvar2dyndelay} className='small_services_box small_services_box-bigbottom' initial="hidden" exit="hidden" whileInView="visible" custom={0.3} viewport={{ once: false, margin: "-50px" }}>
                                <div className='small_services_textbox'>
                                    <h3>&lt;Individuelle Entwicklung und Beratung/&gt;</h3>
                                    <br /><br />
                                    <p>
                                        Du bist bei unseren Leistungen nicht fündig geworden? Wir sind offen für Herausforderungen 😉<br />
                                        Wir stehen dir mit Expertise zur Seite und entwickeln bspw. ein Branding für deine Marke, eine Elektronikkomponente oder eine individuelle Softwarelösung für dich.
                                    </p>
                                    <CTAButton className="" showArrow={true} customIcon={null} iconLeft={false} title={"Jetzt anfragen"} href={'/support'}></CTAButton>
                                </div>
                            </motion.div>
                        </div>
                    </motion.div>

                </div>
            </section >

            <MainFooter />
        </div >
    )
}